import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'
import router from '@/router'

const service = axios.create({
  baseURL: '/api',
  timeout: 30000,
  // 数组参数序列化为 ids=16&ids=15（不带方括号），
  // 避免 axios 默认的 ids[]=16&ids[]=15 触发 Tomcat RFC 7230/3986 严格校验失败。
  // Spring MVC 的 @RequestParam List<Long> ids 同名重复参数可直接接收。
  // axios 0.27 的 paramsSerializer 必须是函数（对象形式是 1.x 才支持的）
  paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
})

service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

function handleUnauthorized(message) {
  Message.error(message || '登录已过期，请重新登录')
  localStorage.clear()
  if (router.currentRoute.path !== '/login') {
    router.push('/login')
  }
}

service.interceptors.response.use(
  response => {
    const res = response.data
    // blob / arraybuffer 响应直接返回，不做 code 校验
    if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
      return res
    }
    if (res.code === 401) {
      handleUnauthorized(res.message)
      const err = new Error(res.message || '登录已过期')
      err.code = 401
      return Promise.reject(err)
    }
    if (res.code !== 200) {
      // 业务错误，抛出带message的错误供页面catch
      const err = new Error(res.message || '请求失败')
      err.code = res.code
      Message.error(res.message || '请求失败')
      return Promise.reject(err)
    }
    return res
  },
  error => {
    if (error.response?.status === 401) {
      handleUnauthorized(error.response?.data?.message)
      return Promise.reject(new Error('登录已过期'))
    }
    const msg = error.response?.data?.message || error.message || '网络错误'
    Message.error(msg)
    return Promise.reject(new Error(msg))
  }
)

export default service
